import getQueryParam from './getQueryParam'
import { systemShareLogin } from '@/api'
import { Dialog } from 'vant'
// 存储URL参数到本地存储
function setUrlParams() {
  localStorage.clear()
  systemShareLogin({
    pdseq: getQueryParam('pdseq'),
    token: getQueryParam('token'),
    timestamp: getQueryParam('timestamp'),
    pdsign: getQueryParam('pdsign')
  }).then(res => {
    if (res.data.info == 10118308) {
      localStorage.setItem('zlVipAccountId', res.data.data.accountid)
      localStorage.setItem('zlVipUserList', JSON.stringify(res.data.data.userlist))
      localStorage.setItem('zlVipSignature', res.data.data.signature)
      localStorage.setItem('zlVipExpire', res.data.data.expire)
      let baseUrl = window.location.href.split('?')[0];
      window.location.href = baseUrl
    } else {
      Dialog.alert({
        message: `登录信息已过期，请重新登录`,
      }).then(() => {
        // on close
        localStorage.clear()
        let baseUrl = window.location.href.split('?')[0];
        window.location.href = baseUrl
      });
    }
  })
}

export { setUrlParams }
